import { useContext } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import MenuUi from "./../../../helpers/MenuUi/MenuUi";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ValidationErrorMessage from "../../../helpers/ValidationErrorMessage/ValidationErrorMessage";

import { HiEye, HiEyeOff } from "react-icons/hi";

import {
  changePasswordCustomerValidation,
  confirmChangePasswordCustomerValidation,
} from "../../../utils/validation/validation";

import { changePasswordCustomerContext } from "../../../context/CustomerContext/ChangePasswordCustomerContext/ChangePasswordCustomerContext";

const CustomerChangePassword = () => {
  const {
    isCodeSent,
    handleChangePassword,
    handleConfirmChangePassword,
    isShowCurrentPass,
    setIsShowCurrentPass,
    isShowNewPass,
    setIsShowNewPass,
    isShowConfirmPass,
    setIsShowConfirmPass,
    handleChangePin,
    changePin,
    setChangePin,
    confirmChangePin,
    setConfirmChangePin,
    pinPhoneNumber,
    setPinPhoneNumber,
    pinPassword,
    setPinPassword,
    view,
    setView,
  } = useContext(changePasswordCustomerContext);

  // Validation Change Password
  const {
    register: registerForm1,
    handleSubmit: handleSubmitForm1,
    formState: { errors: errorsForm1 },
  } = useForm({
    resolver: yupResolver(changePasswordCustomerValidation),
  });

  // Validation Confirm Change Password
  const {
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    formState: { errors: errorsForm2 },
  } = useForm({
    resolver: yupResolver(confirmChangePasswordCustomerValidation),
  });

  return (
    <>
      <SiteTitle title="تغییر رمز عبور" />
      <div className="mr-auto w-full h-full">
        <div className="flex h-full justify-center items-center rounded-xl bg-mainBackground relative">
          <div className="rounded-xl flex flex-col h-full w-full animate__animated animate__fadeIn animate__fast">
            <div className="w-full flex flex-col items-center justify-center h-screen px-5">
              <div className="flex flex-col -mt-5 w-full max-w-lg mx-auto rounded-lg border-2 border-boxColor">
                {/* Menu */}
                <MenuUi className={"top-3"} />
                <div className="bg-boxColor py-5">
                  {/* Title */}
                  <span className="text-lg text-slate-200 w-full flex justify-center items-center">
                    <span
                      className={`${
                        view === "password"
                          ? "text-green-500"
                          : "text-slate-200"
                      } cursor-pointer`}
                      onClick={() => setView("password")}
                    >
                      تغییر رمز عبور
                    </span>
                    <span className="mx-3">-</span>
                    <span
                      className={`${
                        view === "pin" ? "text-green-500" : ""
                      } cursor-pointer`}
                      onClick={() => setView("pin")}
                    >
                      تغییر پین
                    </span>
                  </span>
                  {/* Pin */}
                  {view === "pin" && (
                    <>
                      <div className="w-full px-6 py-5 ">
                        <form onSubmit={handleChangePin}>
                          <div className="grid grid-cols-1 gap-x-3 w-full">
                            <span className="animate__animated animate__fadeIn animate__fast">
                              {/* Phone Number */}
                              <span>
                                <label
                                  htmlFor="phonenumber"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  شماره موبایل
                                </label>
                                <input
                                  type="text"
                                  name="phonenumber"
                                  placeholder="شماره موبایل"
                                  autoComplete="off"
                                  value={pinPhoneNumber}
                                  onChange={(e) =>
                                    setPinPhoneNumber(e.target.value)
                                  }
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                              </span>
                              {/* New Pin */}
                              <span>
                                <label
                                  htmlFor="newPin"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  پین جدید
                                </label>
                                <input
                                  type="text"
                                  name="newPin"
                                  placeholder="پین جدید"
                                  autoComplete="off"
                                  value={changePin}
                                  onChange={(e) => setChangePin(e.target.value)}
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                              </span>
                              {/* Confirm New Pin */}
                              <span>
                                <label
                                  htmlFor="confirmPin"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  تکرار پین جدید
                                </label>
                                <input
                                  type="text"
                                  name="confirmPin"
                                  placeholder="تکرار پین جدید"
                                  autoComplete="off"
                                  value={confirmChangePin}
                                  onChange={(e) =>
                                    setConfirmChangePin(e.target.value)
                                  }
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                              </span>
                              {/* Password */}
                              <span>
                                <label
                                  htmlFor="password"
                                  className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                >
                                  رمز عبور
                                </label>
                                <input
                                  type="text"
                                  name="password"
                                  placeholder="رمز عبور"
                                  autoComplete="off"
                                  value={pinPassword}
                                  onChange={(e) =>
                                    setPinPassword(e.target.value)
                                  }
                                  className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                  rounded-md focus:right-0 focus:outline-none tracking-wide
                                  placeholder-gray-600 bg-zinc-900 text-gray-400
                                  focus:border-gray-200 focus:text-gray-200"
                                />
                              </span>
                            </span>
                          </div>
                          {/* Button */}
                          <div className="flex items-center justify-end p-5 w-full">
                            <button
                              type="submit"
                              className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                            >
                              تغییر پین
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  )}
                  {/* Password */}
                  {view === "password" && (
                    <>
                      <div className="w-full px-6 py-5 ">
                        {/* First Form */}
                        {!isCodeSent && (
                          <>
                            <form
                              onSubmit={handleSubmitForm1(handleChangePassword)}
                            >
                              <div className="grid grid-cols-1 gap-x-3 w-full">
                                <span className="animate__animated animate__fadeIn animate__fast">
                                  {/* Phone Number */}
                                  <span>
                                    <label
                                      htmlFor="phonenumber"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      شماره موبایل
                                    </label>
                                    <input
                                      type="text"
                                      name="phonenumber"
                                      placeholder="شماره موبایل"
                                      autoComplete="off"
                                      {...registerForm1("phonenumber")}
                                      className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
rounded-md focus:right-0 focus:outline-none tracking-wide
placeholder-gray-600 bg-zinc-900 text-gray-400
focus:border-gray-200 focus:text-gray-200"
                                    />
                                    <span>
                                      <ValidationErrorMessage
                                        message={
                                          errorsForm1.phonenumber?.message
                                        }
                                      />
                                    </span>
                                  </span>
                                  {/* Current password */}
                                  <span className="relative">
                                    <label
                                      htmlFor="currentPassword"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      رمز عبور فعلی
                                    </label>
                                    <input
                                      type={
                                        isShowCurrentPass ? "text" : "password"
                                      }
                                      name="currentPassword"
                                      placeholder="رمز عبور فعلی"
                                      autoComplete="off"
                                      {...registerForm1("currentPassword")}
                                      className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
rounded-md focus:right-0 focus:outline-none tracking-wide
placeholder-gray-600 bg-zinc-900 text-gray-400
focus:border-gray-200 focus:text-gray-200"
                                    />
                                    {/* Show/Hide Password Icon */}
                                    <span className="absolute left-2.5 bottom-1">
                                      {isShowCurrentPass ? (
                                        <HiEye
                                          onClick={() =>
                                            setIsShowCurrentPass(
                                              !isShowCurrentPass
                                            )
                                          }
                                          fill="#fff"
                                          className="cursor-pointer"
                                        />
                                      ) : (
                                        <HiEyeOff
                                          onClick={() =>
                                            setIsShowCurrentPass(
                                              !isShowCurrentPass
                                            )
                                          }
                                          fill="#fff"
                                          className="cursor-pointer"
                                        />
                                      )}
                                    </span>
                                    <span>
                                      <ValidationErrorMessage
                                        message={
                                          errorsForm1.currentPassword?.message
                                        }
                                      />
                                    </span>
                                  </span>
                                </span>
                              </div>
                              {/* Button */}
                              <div className="flex items-center justify-end pt-5 w-full">
                                <button
                                  type="submit"
                                  className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                                >
                                  دریافت کد
                                </button>
                              </div>
                            </form>
                          </>
                        )}
                        {/* Second Form */}
                        {isCodeSent && (
                          <form
                            onSubmit={handleSubmitForm2(
                              handleConfirmChangePassword
                            )}
                          >
                            <div className="grid grid-cols-1 gap-x-3 w-full">
                              <>
                                <span className="animate__animated animate__fadeIn animate__fast">
                                  {/* New Password */}
                                  <span className="relative">
                                    <label
                                      htmlFor="newPassword"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      رمز عبور جدید
                                    </label>
                                    <input
                                      type={isShowNewPass ? "text" : "password"}
                                      name="newPassword"
                                      placeholder="رمز عبور جدید"
                                      autoComplete="off"
                                      {...registerForm2("password")}
                                      className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                rounded-md focus:right-0 focus:outline-none tracking-wide
                                placeholder-gray-600 bg-zinc-900 text-gray-400
                                focus:border-gray-200 focus:text-gray-200"
                                    />
                                    {/* Show/Hide Password Icon */}
                                    <span className="absolute left-2.5 bottom-1">
                                      {isShowNewPass ? (
                                        <HiEye
                                          onClick={() =>
                                            setIsShowNewPass(!isShowNewPass)
                                          }
                                          fill="#fff"
                                          className="cursor-pointer"
                                        />
                                      ) : (
                                        <HiEyeOff
                                          onClick={() =>
                                            setIsShowNewPass(!isShowNewPass)
                                          }
                                          fill="#fff"
                                          className="cursor-pointer"
                                        />
                                      )}
                                    </span>
                                    <span>
                                      <ValidationErrorMessage
                                        message={errorsForm2.password?.message}
                                      />
                                    </span>
                                  </span>
                                  {/* Confirm New password */}
                                  <span className="relative">
                                    <label
                                      htmlFor="confirmPassword"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      تکرار رمز عبور جدید
                                    </label>
                                    <input
                                      type={
                                        isShowConfirmPass ? "text" : "password"
                                      }
                                      name="confirmPassword"
                                      placeholder="تکرار رمز عبور جدید"
                                      autoComplete="off"
                                      {...registerForm2("confirmpassword")}
                                      className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                rounded-md focus:right-0 focus:outline-none tracking-wide
                                placeholder-gray-600 bg-zinc-900 text-gray-400
                                focus:border-gray-200 focus:text-gray-200"
                                    />
                                    {/* Show/Hide Password Icon */}
                                    <span className="absolute left-2.5 bottom-1">
                                      {isShowConfirmPass ? (
                                        <HiEye
                                          onClick={() =>
                                            setIsShowConfirmPass(
                                              !isShowConfirmPass
                                            )
                                          }
                                          fill="#fff"
                                          className="cursor-pointer"
                                        />
                                      ) : (
                                        <HiEyeOff
                                          onClick={() =>
                                            setIsShowConfirmPass(
                                              !isShowConfirmPass
                                            )
                                          }
                                          fill="#fff"
                                          className="cursor-pointer"
                                        />
                                      )}
                                    </span>
                                    <span>
                                      <ValidationErrorMessage
                                        message={
                                          errorsForm2.confirmpassword?.message
                                        }
                                      />
                                    </span>
                                  </span>
                                  {/* Verify Code */}
                                  <span>
                                    <label
                                      htmlFor="verifyCode"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      کد تأیید
                                    </label>
                                    <input
                                      type="text"
                                      name="verifyCode"
                                      placeholder="کد تأیید"
                                      autoComplete="off"
                                      {...registerForm2("token")}
                                      className="p-2 mb-2 bg-transparent border-2 border-slate-600 w-full
                                rounded-md focus:right-0 focus:outline-none tracking-wide
                                placeholder-gray-600 bg-zinc-900 text-gray-400 text-center
                                focus:border-gray-200 focus:text-gray-200"
                                    />
                                    <span>
                                      <ValidationErrorMessage
                                        message={errorsForm2.token?.message}
                                      />
                                    </span>
                                  </span>
                                </span>
                              </>
                            </div>
                            {/* Button */}
                            <div className="flex items-center justify-end pt-5 w-full">
                              <button
                                type="submit"
                                className="px-4 py-1.5 text-white text-sm font-medium bg-green-500 hover:bg-green-600 rounded"
                              >
                                تغییر رمز عبور
                              </button>
                            </div>
                          </form>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerChangePassword;
